/**
 * Typed manifest mirror of the backend module.json. Keeping id / permission /
 * paths in a typed module lets tsc validate the route + permission strings the
 * definition wires up.
 */
export const MODULE_ID = 'network-status-widget' as const;

export const MODULE_PERMISSION = 'module.network_status_widget.view' as const;

export const MODULE_BASE_PATH = '/admin/modules/network-status-widget' as const;

/** i18next namespace (mirrors the backend `module_<id_snake>` namespace). */
export const MODULE_I18N_NAMESPACE = 'module_network_status_widget' as const;
